import err from './err';
import user from './user';
import sys from './sys';
import group from './group';
import worker from './worker';
import session from './session';
import contract from './contract';
import aiCheck from './aiCheck';
import authority from './authority';

const req = {
  err,
  user,
  sys,
  group,
  worker,
  session,
  contract,
  aiCheck,
  authority,
};

export default req;
